import { apply, tw } from "twind/css"

export const card = apply`py-4`

export const colContainer = apply`flex(& col lg:row) gap-8`

export const colWide = apply`flex(& col) flex-[5] gap-2`

export const colNarrow = apply`flex(& col) flex-[3] gap-4`

export const h1 = tw`text-3xl font-semibold mb-6`

export const h2 = tw`text-2xl font-semibold mb-5`

export const h3 = tw`text-xl mb-4`

export const auxContainer = tw`max-w-screen-md mx-auto my-8`
